// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 284 ? "ba1712fc" : chunkId) + "." + {"284":"17af03ff068757ea","436":"60201d62a3e1a433","856":"397221030117d7ba"}[chunkId] + ".js";
};